import { currencies } from '../src/currencies.ts';
export default currencies;
export type { SupportedCurrencies } from '../src/currencies.ts';
